var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAni3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.95 10.9993C19.6971 9.07007 18.7498 7.29911 17.2853 6.01795C15.8209 4.7368 13.9397 4.03328 11.9939 4.0391C10.0482 4.04492 8.17124 4.75967 6.71447 6.04956C5.2577 7.33945 4.32097 9.11605 4.07963 11.0468C3.83829 12.9775 4.30888 14.93 5.40331 16.5388C6.49775 18.1476 8.14099 19.3024 10.0254 19.787C11.9099 20.2716 13.9064 20.0528 15.6411 19.1715C17.3759 18.2903 18.73 16.807 19.45 14.9993M19.95 19.9993V14.9993H14.95",
    stroke: "#C8BEBE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAni3);
export default __webpack_public_path__ + "static/media/Ani3.f41341ce5ed80896c46bc4a45d030969.svg";
export { ForwardRef as ReactComponent };